import React from "react";
import VideoCard from '../components/VideoCard';

const VideoStream = () => {
    return <VideoCard />;
}

export default VideoStream;